import { createFileRoute } from '@tanstack/react-router'
import PageEntrance from '~components/motion/page-entrance'
import SelectPet from '~containers/app/ask-a-vet/2_select-pet'

export const Route = createFileRoute('/samsung/smart-things/(app)/ask-a-vet/select-pet')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <PageEntrance>
      <SelectPet />
    </PageEntrance>
  )
}
